var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#59B949"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 25a2 2 0 01-2 2H10a2 2 0 01-2-2V11a2 2 0 012-2h5l2 3h9a2 2 0 012 2v11z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IiM1OUI5NDkiLz4KPHBhdGggZD0iTTI4IDI1QzI4IDI1LjUzMDQgMjcuNzg5MyAyNi4wMzkxIDI3LjQxNDIgMjYuNDE0MkMyNy4wMzkxIDI2Ljc4OTMgMjYuNTMwNCAyNyAyNiAyN0gxMEM5LjQ2OTU3IDI3IDguOTYwODYgMjYuNzg5MyA4LjU4NTc5IDI2LjQxNDJDOC4yMTA3MSAyNi4wMzkxIDggMjUuNTMwNCA4IDI1VjExQzggMTAuNDY5NiA4LjIxMDcxIDkuOTYwODYgOC41ODU3OSA5LjU4NTc5QzguOTYwODYgOS4yMTA3MSA5LjQ2OTU3IDkgMTAgOUgxNUwxNyAxMkgyNkMyNi41MzA0IDEyIDI3LjAzOTEgMTIuMjEwNyAyNy40MTQyIDEyLjU4NThDMjcuNzg5MyAxMi45NjA5IDI4IDEzLjQ2OTYgMjggMTRWMjVaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgCircleFolder as ReactComponent };